import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FleetGeofenceService } from '@pages/fleet/services/fleet-geofence.service';
import { RegistryComponentNames } from '@shared/constants/registry-component-name';
import { PipesModule } from '@shared/pipes/pipes.module';
import { GeofenceInfoBoxComponent } from '../geofence-info-box/geofence-info-box.component';
import { DvButtonComponent, DvTooltipDirective } from '@devinco/ui/dds';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { Observable } from 'rxjs';
import {
  UserStatusIcons,
  UserStatusTranslationKey,
} from '@shared/constants/user-status';

@Component({
  imports: [
    CommonModule,
    PipesModule,
    TranslateModule,
    GeofenceInfoBoxComponent,
    DvButtonComponent,
    DvTooltipDirective,
  ],
  selector: RegistryComponentNames.DriverPopupContent,
  templateUrl: './driver-popup-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./driver-popup-content.component.scss'],
})
/** This component currently is used as custom angular elemement. Before using, keep in mind that all input values
 * for custom elements are coming as stringified values.
 */
export class DriverPopupContentComponent implements OnInit {
  private fleetGeofenceService = inject(FleetGeofenceService);
  private permissionsService = inject(UserRolesAndPermissionsService);

  @Input() carIconUrl: string;
  @Input() vehicleDescription: string;
  @Input() userDescription?: string;
  @Input() userName?: string;
  @Input() userMobile?: string;
  @Input() lastActivityTime?: string;
  @Input() lat?: string;
  @Input() lng?: string;
  // asset id
  @Input() id?: string;
  // geofence's, that's attached to popup ID
  @Input() geofenceId?: string;
  // entity id (entity popup is attached to ID)
  @Input() entityId?: string;
  @Input() showGeofence?: 'true' | 'false' = 'false';
  @Input() hasTemporaryGeofence?: 'true' | 'false' = 'false';
  @Input() mapsUrl: string;
  userStatusKey = input<UserStatusTranslationKey>();

  readonly UserStatusIcons = UserStatusIcons;
  readonly keyUserNoStatus = UserStatusTranslationKey.NoStatus;

  canEditTempGeofence$: Observable<boolean>;

  ngOnInit(): void {
    this.canEditTempGeofence$ = this.permissionsService.hasPermissions([
      RolesAndPermissions.FleetTemporaryGeofenceEdit,
    ]);
  }

  onCreateTempGeofenceClick(): void {
    if (!this.lat || !this.lng) return;
    this.fleetGeofenceService.openTempGeofenceCreationPopup({
      TrackerObjectID: Number(this.id!),
      Coordinates: { lat: Number(this.lat), lng: Number(this.lng) },
      PopupDescription: this.vehicleDescription,
      EntityId: this.entityId,
      GeofenceId: this.geofenceId,
    });
  }

  onGeofenceDeleteClicked(geofenceId?: string): void {
    if (!geofenceId) return;
    this.fleetGeofenceService.deleteFleetLocation(
      Number(geofenceId),
      this.entityId
    );
  }

  openInGoogleMaps(url: string): void {
    window.open(url, '_blank');
  }
}
